/**
 * 应用配置
 */
export default {
  // API 基础地址
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  // 请求超时时间（毫秒）
  timeout: 15000,
  // 应用标题
  title: '患者随访管理'
}
